import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface PropTypes {
    question: string;
    answer: string;
}

function FaqItem(props: PropTypes): JSX.Element {
    const theme = useTheme();
    return (
        <Box
            component={Accordion}
            padding={1}
            marginBottom={2}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
                '&::before': {
                    display: 'none',
                },
            }}
        >
            <Box
                component={AccordionSummary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id={'panel1a-header'}
            >
                <Typography fontWeight={600}>{props.question}</Typography>
            </Box>
            <AccordionDetails>
                <Typography color="text.secondary">{props.answer}</Typography>
            </AccordionDetails>
        </Box>
    );
}

export default FaqItem;